import React, {useEffect, useState} from 'react';
import InstallationTable from "../../Tables/InstallationTable";
import {useSelector} from "react-redux";
import {installationSelect} from "../../../redux-store/selectors";
import api from "../../../api/apiInterceptor";
import Loader from "../../ApplicationComponent/Loader";


const TablesHomePage = () => {

    const [tableList, setTableList] = useState([])
    const [loader, setLoader] = useState(false)

    const installationSelectValue = useSelector(installationSelect)

    const fetchTableListData = async () => {
        setLoader(true)
        let tablesResult = await api.get(`/api/installations/${installationSelectValue.value}/tableviews`)
        setLoader(false)
        setTableList(tablesResult.data)
    }

    useEffect(() => {
        if (installationSelectValue.value) {
            fetchTableListData()
        }
    }, [installationSelectValue.value])

    
    function Archive(selectedInstallation)
    {
        console.log(selectedInstallation.installationId.value);
        if (selectedInstallation.installationId.value === 14)
        {
            return <a href="/archive/" target='_blank'>Arhiva</a>
        } else {
            return '';
        }
    }

    return (
        <>
            {tableList.length === 0 && (
                <div className={"container"}>
                    <div className={"row pt-5"}>
                        <div className={"col-12 text-center"}>
                            <h3>TRENUTNO ZA OVU INSTALACIJU NEMA PODATAKA</h3>
                        </div>
                    </div>
                </div>
            )}
            <Archive installationId={installationSelectValue} />
            {loader ? <Loader/> : tableList.map((table) => (
                <InstallationTable key={table.id} id={table.id}/>
            ))}
        </>
    );
};

export default TablesHomePage;
